import superagent from "superagent";
import { UserView } from "react-materialize";

export const loginAs = (user) => {
  return (dispatch, getState, {getFirebase}) => {
      dispatch({ type: 'LOGIN_SUCCESS', user: user });
  }
};

export const signIn = (phone) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    
    // firebase.auth().signInWithEmailAndPassword(
    //   credentials.email,
    //   credentials.password
    // ).then(() => {
    //   dispatch({ type: 'LOGIN_SUCCESS', email: credentials.email });
    // }).catch((err) => {
    //   dispatch({ type: 'LOGIN_ERROR', err });
    // });

    let appVerifier = window.recaptchaVerifier;
    firebase.auth().signInWithPhoneNumber(`+1${phone}`, appVerifier)
    .then(confirmationResult => {
      window.confirmationResult = confirmationResult;
      dispatch({ type: 'LOGIN_VERIFY'});
    }).catch(error => {
      window.recaptchaVerifier.reset(window.recaptchaWidgetId);
      dispatch({ type: 'LOGIN_ERROR', error });
      console.log(error);
      alert("There was a problem sending the text. Please contact the Admin or try again.")
    });

  }
}

export const forgotPass = (email) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();

    firebase.auth().sendPasswordResetEmail(email).then(function() {
      alert("An email has been sent to reset your password");
    }).catch(function(error) {
      alert("An error occured while trying to reset your password");
    });
    
  }
}
  
  export const signOut = () => {
    return (dispatch, getState, {getFirebase}) => {
      const firebase = getFirebase();
      firebase.auth().signOut().then(() => {
        dispatch({ type: 'SIGNOUT_SUCCESS' });
      });
    }
  }